import { Badge } from "@/components/ui/badge";

interface ComplianceBadgeProps {
  score: number | null;
  needsReview?: boolean;
}

export function ComplianceBadge({ score }: ComplianceBadgeProps) {
  if (score === null || score === undefined) {
    return <Badge>Unscored</Badge>;
  }

  if (score >= 80) {
    return <Badge variant="success">{score}%</Badge>;
  }

  if (score >= 50) {
    return <Badge variant="warning">{score}%</Badge>;
  }

  return <Badge variant="danger">{score}%</Badge>;
}
